import React, { Component } from 'react';
import './sec1.css';

const Sec1 = () => {
    return ( 
        <div className='sec1'>
            <h3>A Historical Journey</h3>
            <h1>A Historical Journey</h1>
            <p>Renaissance Polymath & Visionary Genius</p>
            <p>1452 - 1519</p>
            <button className="story-button">
  EXPLORE THE STORY
  <span className="arrow">↓</span>
</button>
<div className="hero-year-stamp">1452</div>
        </div>


     );
}
 
export default Sec1;